export default {"src":"/_next/static/media/vglogo.a5fa8902.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};